import { Component, Input } from '@angular/core';

@Component({
  selector: 'movie-card',
  templateUrl: './movie-card.component.html',
  styleUrls: ['./movie-card.component.css']
})
export class MovieCardComponent {

  @Input()
  movie: Object;

}



// WEBPACK FOOTER //
// /Users/macbookproretina13/Projects/ng5/Movies-Finder/src/app/movie-card/movie-card.component.ts